import { render, staticRenderFns } from "./SystemDataObject.vue?vue&type=template&id=60863368&scoped=true&"
import script from "./SystemDataObject.vue?vue&type=script&lang=js&"
export * from "./SystemDataObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60863368",
  null
  
)

export default component.exports